const multipleSlots = function (ss) {
  return ss
    && ss.reduce((acc, s) => acc + (s.slots || []).length, 0) > 1;
}
export default multipleSlots;